import { HabitSchedule } from '@griply/types';
import { isAfter, startOfDay } from 'date-fns';

import { isDegenerateSchedule } from './is-degenerate-schedule';

// Legacy clients appended schedules without capping the previous one, so an
// open-ended schedule is capped at the first later-day sibling's startDate
// (endDate is exclusive). Same-day and degenerate siblings never cap.
export const normalizeSchedules = <
  Schedule extends Pick<HabitSchedule, 'startDate' | 'endDate'>,
>(
  schedules: Schedule[],
): Schedule[] => {
  const validSchedules = schedules.filter(
    (schedule) => !isDegenerateSchedule(schedule),
  );
  const lastStartTime = Math.max(
    ...validSchedules.map(({ startDate }) => startOfDay(startDate).getTime()),
  );
  const needsCapping = validSchedules.some(
    ({ endDate, startDate }) =>
      !endDate && startOfDay(startDate).getTime() < lastStartTime,
  );

  if (!needsCapping) {
    return schedules;
  }

  const byStartDate = [...schedules].sort(
    (scheduleA, scheduleB) =>
      scheduleA.startDate.getTime() - scheduleB.startDate.getTime(),
  );

  return byStartDate.map((schedule, index) => {
    if (schedule.endDate) {
      return schedule;
    }
    const successor = byStartDate
      .slice(index + 1)
      .find(
        (other) =>
          !isDegenerateSchedule(other) &&
          isAfter(startOfDay(other.startDate), startOfDay(schedule.startDate)),
      );
    return successor ? { ...schedule, endDate: successor.startDate } : schedule;
  });
};
